@if ({ data: displayData$ | async, translations: translations$ | async, listLoader: listLoader$ | async }; as $) {
    <adspt-selector-button
        [ngClass]="{ 'disabled-close': disableReset, 'multi-selector': $.data.multpleSelections }"
        nz-dropdown
        nzTrigger="click"
        [(nzVisible)]="isVisible"
        [nzDropdownMenu]="menu"
        [nzClickHide]="false"
        adsptHeap="criteria-global-selector"
        [heapDisabled]="isVisible"
        [showLoader]="loader$ | async"
        [defaultLabel]="$.translations.title"
        [showDefaultLabel]="$.data.src.type === 'LABEL'"
        [label]="$.data.src.payload || $.translations.title"
        [selectionLabels]="$.data.labels.buttonTexts"
        [tooltip]="$.data.labels.tooltip"
        [isOpen]="isVisible"
        (closed)="reset.emit({})"
        (nzVisibleChange)="onDropDownVisibiltiyChange($event)"
    />
    <nz-dropdown-menu #menu="nzDropdownMenu">
        @if (isVisible) {
            <div class="dialog-wrapper">
                <adspt-global-selector-dialog-content
                    [isVisible]="isVisible"
                    [hasDestinationSelector]="false"
                    [selectedTabIndex]="selectedTabIndex"
                    [enableAdvancedMode]="enableAdvancedMode"
                    [enableAdvancedFilterSelection]="enableAdvancedFilterSelection"
                    [subfilterOptions]="subfilterOptions"
                    [obs]="$"
                    [rowItemTmpl]="rowItemTmpl"
                    [srcList]="srcList$"
                    [srcTotalCount]="srcTotalCount$"
                    [hasSrcQuery]="hasSrcQuery$"
                    [heapInfo]="heapInfo"
                    (selectedTabIndexChange)="selectedTabIndex = $event"
                    (notfiy)="onNotifications($event.evt, $event.filterMode)"
                    (refinerChange)="onRefinerChange($event.evt, $event.filterMode)"
                >
                </adspt-global-selector-dialog-content>
            </div>
        }
    </nz-dropdown-menu>
    <ng-template #rowItemTmpl let-data>
        <adspt-account-logo
            class="small-medium a-fx-none"
            [account]="data"
            [showStatus]="true"
            [forceStatus]="data.status"
        />
        <div class="a-fx a-fx-between-center a-fx-gap-16 a-fx-flex">
            <div class="a-fx-col a-fx-gap-4">
                <adspt-account-label [item]="data" labelClass="label-2"></adspt-account-label>
                <adspt-campaign-label [item]="data" labelClass="caption-1"></adspt-campaign-label>
                <adspt-ad-group-label [item]="data" labelClass="caption-1"></adspt-ad-group-label>
                <adspt-criterion-label [item]="data"></adspt-criterion-label>
            </div>
            @if (data.id === $.data.selectedItems[selectedTabIndex ? filterMode.Destination : filterMode.Source]) {
                <svg
                    nz-tooltip
                    [nzTooltipTitle]="'common.remove-selected-item' | translate"
                    class="adspt-icon close-icon"
                    (click)="
                        $event?.stopPropagation();
                        reset.emit({ tab: selectedTabIndex ? filterMode.Destination : filterMode.Source })
                    "
                >
                    <use xlink:href="#adspt-cross-circle"></use>
                </svg>
            }
        </div>
    </ng-template>
}
